export default __webpack_public_path__ + "static/media/graphic.773244b9.png";